import "./DeleteDealDocumentVersionModal.css";

import { Button, Column, Modal, Row } from "../../../../../widget";

interface DeleteDealDocumentVersionModalProps {
  show: boolean;
  isLoading: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const DeleteDealDocumentVersionModal = ({
  show,
  isLoading,
  onConfirm,
  onCancel,
}: DeleteDealDocumentVersionModalProps): JSX.Element => {
  return (
    <div className="DeleteDealDocumentVersionModal">
      <Modal show={show} title="Delete document version?" onClose={onCancel}>
        <Row spacingV="ml" justify="center">
          <Column span={10}>
            <p className="DeleteDealDocumentVersionModalBody body1">
              Are you sure you want to delete this document version?
            </p>
          </Column>
        </Row>
        <Row justify="center">
          <Column span={8}>
            <div className="DeleteDealDocumentVersionModalButtons">
              <Button text="Delete" onClick={onConfirm} isLoading={isLoading} corners="rounded" />
              <Button variant="secondary" text="Cancel" onClick={onCancel} corners="rounded" />
            </div>
          </Column>
        </Row>
      </Modal>
    </div>
  );
};
